const links = {
    headerLogoUrl: 'https://www.bpoint.com.au/bpoint/'
};

export default links;